module.exports = {
	"DiscoDisco": "dd",
	"FortyThieves": "40t",
	"HerosQuest": "hq",
	"HeroesQuest": "hq",
	"HerculesMagnus": "hm",
	"LuckyIrish": "li",
	"Mighty40": "m40",
	"MysticForce": "mf",
	"gg-love-land": "li"
};


//////////////////
// WEBPACK FOOTER
// ./config/themes.yaml
// module id = 53
// module chunks = 4